import { parse } from "@xmpp/jid"

export const CHAT_LINK_PARAM = "mucJid"
export const SHARED_ROUTE_PARAM = "routeId"
export const TAB_PARAM = "tab"
export const PLANNER_TAB = "plan-order"

export function getLinkedChatJid(search: string): string | null {
  const value = new URLSearchParams(search).get(CHAT_LINK_PARAM)
  if (!value || /\s/.test(value)) return null
  try {
    const jid = parse(value)
    return jid.local && jid.domain && !jid.resource ? jid.toString() : null
  } catch {
    return null
  }
}

const SHARED_ROUTE_ID = /^[A-Za-z0-9]{1,64}$/

export function getSharedRouteId(search: string): string | null {
  const value = new URLSearchParams(search).get(SHARED_ROUTE_PARAM)
  return value && SHARED_ROUTE_ID.test(value) ? value : null
}

export function plannerPath(routeId: string | null): string {
  const params = new URLSearchParams({ [TAB_PARAM]: PLANNER_TAB })
  if (routeId) params.set(SHARED_ROUTE_PARAM, routeId)
  return `/?${params}`
}

export function entryPath(path: string, search: string): string {
  const params = new URLSearchParams()
  const jid = getLinkedChatJid(search)
  if (jid) params.set(CHAT_LINK_PARAM, jid)
  const routeId = getSharedRouteId(search)
  if (routeId || new URLSearchParams(search).get(TAB_PARAM) === PLANNER_TAB) {
    params.set(TAB_PARAM, PLANNER_TAB)
  }
  if (routeId) params.set(SHARED_ROUTE_PARAM, routeId)
  const query = params.toString()
  return query ? `${path}?${query}` : path
}

export function createChatLink(jid: string): string {
  const url = new URL("/", window.location.origin)
  url.searchParams.set(CHAT_LINK_PARAM, jid)
  return url.toString()
}
